
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["binomial"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4011c558981cb2bc3352.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			